import { END } from 'redux-saga';
import { isServer } from '@util/is-server';

export const handleServerSideSagas = async (store: any) => {
  if (isServer) {
    store.dispatch(END);
    await store.sagaTask.toPromise();
  }
};
